import React, { forwardRef, HTMLAttributes, memo } from "react";
import classNames from "classnames";
import { FileUploadBase, FileUploadBaseProps } from "../FileUploadBase";
import { FileUploadItem, FileUploadItemProps } from "../FileUploadItem";

import styles from "./style.module.scss";

export type FileUploadProps = FileUploadBaseProps & {
  error?: boolean | boolean[]
  progress?: number | number[]
  containerProps?: HTMLAttributes<HTMLDivElement>
  supportingText?: string
  fileUploadItemProps?: FileUploadItemProps
  wrapperItemsClassName?: string
};

export const FileUpload = memo(forwardRef<HTMLDivElement, FileUploadProps>((
  {
    error = false,
    progress = 0,
    containerProps,
    fileUploadItemProps,
    wrapperItemsClassName,
    ...props
  },
  ref,
) => {
  const fileList = props.value
    ? (Array.isArray(props.value) ? props.value : [ props.value ])
    : [];

  return (
    <div
      className={classNames(styles.root, containerProps?.className)}
      ref={ref}
      {...containerProps}
    >
      <FileUploadBase
        {...props}
      />
      <div className={classNames(styles.wrapperItems, wrapperItemsClassName)}>
        {fileList?.map((file: File, index: number) => {
          return (
            <FileUploadItem
              key={file.name + file.size}
              {...fileUploadItemProps}
              file={file}
              progress={Array.isArray(progress) ? progress[index] : progress}
              error={Array.isArray(error) ? error[index] : error}
              removeFile={() => {
                if (Array.isArray(props?.value)) {
                  const updatedFileList = props.value.filter((currentFile) => currentFile !== file);
                  props.onChange?.(updatedFileList);
                } else {
                  props.onChange?.(null);
                }
              }}
            />
          );
        })}
      </div>
    </div>
  );
}));


